import axios from '../../axios'
// 打印准考证
export const getIdentityInfo = (data) => {
    return axios({
        url: '/api/mock/aff/print',
        method: 'get',
        data
    })
}

// 打印桌贴
export const getRoomSeatList = (data) => {
    return axios({
        url: '/api/mock/aff/room_seat',
        method: 'get',
        data
    })
}

// 批量打印准考证
export const getTicketListByEaa = (data) => {
    return axios({
        url: '/api/mock/aff/ticket_list',
        method: 'get',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/aff/print.js